/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconDiamond = createReactComponent("outline", "diamond", "IconDiamond", [["path", { "d": "M6 5h12l3 5l-8.5 9.5a.7 .7 0 0 1 -1 0l-8.5 -9.5l3 -5", "key": "svg-0" }], ["path", { "d": "M10 12l-2 -2.2l.6 -1", "key": "svg-1" }]]);

export { IconDiamond as default };
//# sourceMappingURL=IconDiamond.mjs.map
